import * as Yup from "yup";

export type questionIp = {
  state_id: string;
  college_id: string;
  ipAddress: string;
  status: string;
  expiry_from: string;
  expiry_to: string;
};

export const questionIpInitialValues: questionIp = {
  state_id: "",
  college_id: "",
  ipAddress: "",
  status: "active",
  expiry_from: "",
  expiry_to: "",
};

export const questionIpMandatoryFields = [
  { id: "state_id" },
  { id: "college_id" },
  { id: "ipAddress" },
  { id: "status" },
  { id: "expiry_from" },
  { id: "expiry_to" }
];

export const questionIpValidationSchema = Yup.object().shape({
});

export const questionIpProperties = [
   {
      id: "state_id",
      type: "single-select-dependency",
      label: "State",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      required: true,
      list: "state_list",
      keyValue: { label: "state_name", value: "state_id" },
      dependentFields: ["college_list"],
      dependentFlds: {
        state_list: "state_list",
      },
    },
    {
      id: "college_id",
      type: "single-select-dependency",
      label: "College",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      isDependent: true,
      options: [],
      list: "college_list",
      dependencyLabel: "Please select State",
      keyValue: { label: "college_name", value: "college_id" },
      fieldKeyLists: {},
    },
  {
    id: "ipAddress",
    type: "text",
    label: `IP Address`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "active" },
      { label: "Deactivated", value: "deactivated" },
    ],
    hideNone: true,
  },
  {
    id: "expiry_from",
    type: "date-picker",
    label: "Expiry From",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    leadGen:true,
    dateType:"start",
    relative:"expiry_to"
  },
  {
    id: "expiry_to",
    type: "date-picker",
    label: "Expiry to",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    leadGen:true,
    dateType:"end",
    relative:"expiry_from"
  },
];
